import { faTimes } from '@fortawesome/pro-light-svg-icons'
import { StockParentModelType } from '@teinor/erp/types/company/product/stockParent'
import { WarehouseModelType } from '@teinor/erp/types/company/warehouse'
import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import ModalCreateEdit from '../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import CustomSelect from '../../../../../../../../../forms/CustomSelect'
import { FormRender } from '../../../../../../../../../forms/FormRenderer/types'
import { OnSubmit } from '../../../../../../../../../forms/TwinForm/types'
import SearchBarProduct from '../../../../../../../../../specificComponents/Product/SearchBarProduct'
import { ProductExtendedTyShort } from '../../../../../../../../../specificComponents/Product/types'
import { twinFetchPostJSON } from '../../../../../../../../../utils/globals/data'
import { valueOrDefaultValue } from '../../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveCurrenciesDictionary } from '../../../../../../../../../utils/reducers/getters'
import { changeErrorMessage } from '../../../../../../../../../utils/reducers/reduxDispatch'

interface ModalCEWarehouseProductProps extends ModalEditComponentProps { }

const ModalCEWarehouseProduct: React.FC<ModalCEWarehouseProductProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { id, onError, t, warehouse } = useModalCEWarehouseProductLogic()
    const fields: FormRender<StockParentModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'WarehouseId',
                    label: t('warehouse', 'Almacén'),
                    component: 'CustomSelectWithSearchBar',
                    items: { [parseInt(String(id))]: { name: warehouse?.name } },
                    value: id,
                    readOnly: true
                },
                {
                    name: 'ProductId',
                    component: 'Custom',
                    render: () => <SelectorSearchbarDeciderComponent selectedProduct={allRowData?.ProductId ? { id: allRowData?.ProductId, name: allRowData?.Product?.ProductLangs[0].name } : undefined} />
                },
                {
                    name: 'CurrencyId',
                    label: t('currency', 'Moneda'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveCurrenciesDictionary(),
                    value: allRowData?.CurrencyId,
                    required: true
                },
                {
                    name: 'location',
                    label: t('location', 'Localización'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'minimum',
                    label: t('minimum', 'Mínimo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'optimum',
                    label: t('optimum', 'Óptimo'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                }
            ],
        },
    ]

    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <ModalCreateEdit className='notFlexAutoFormRender' fields={parsedFields} url={'/api/app/product/stock/updateParentStock'} translations={{
                title: t('editStock', 'Editar stock') + ' - ' + allRowData?.basicData?.name,
                button: t('save', 'Guardar')
            }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} onChangeError={onError} />
        )
    }
    return (<ModalCreateEdit fields={fields} url={'/api/app/product/stock/createParentStock'} translations={{
        title: t('createStockProduct', 'Crear stock de un producto'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} onChangeError={onError} />)
}

const useModalCEWarehouseProductLogic = () => {
    const { t } = useTwinTranslation()
    const [warehouse, setWarehouse] = useState<WarehouseModelType | null>(null)
    const params = useParams()
    const errorMsg = t('checkProductExistsInWarehouse', 'Comprueba si el producto ya está en este Almacén')
    const id = params.id
    const getWareHouse = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/warehouse/getWarehouseInstance', { id })
        if (result) {
            setWarehouse(result)
        }
    }, [setWarehouse, id])

    const onError: OnSubmit = useCallback(async (e, vals) => {
        changeErrorMessage(errorMsg)
    }, [errorMsg])

    useEffect(() => {
        getWareHouse()
    }, [getWareHouse])

    return { onError, t, id, warehouse }
}


interface SelectorSearchbarDeciderComponentProps extends SelectorSearchbarDeciderComponentLogicProps {
    selectedProduct?: {
        id: number
        name: string
    }
}

const SelectorSearchbarDeciderComponent: React.FC<SelectorSearchbarDeciderComponentProps> = ({selectedProduct}) => {
    const { data, setData } = useSelectorSearchbarDeciderComponentLogic()
    const { t } = useTwinTranslation()
    if (selectedProduct?.id) {
        return <CustomSelect name='ProductId' value={selectedProduct.id} readOnly={true} label={t('product', 'Producto')} items={{ [selectedProduct?.id]: { name: selectedProduct.name } }} />
    }
    if (data?.id) {
        return <CustomSelect name='ProductId' value={data.id} icon={faTimes} readOnly={true} label={t('product', 'Producto')} items={{ [data.id]: { name: data?.['ProductLangs.name'] || data?.name } }} onClickIcon={() => setData(null)} /> 
    }
    return (
        <SearchBarProduct className='searchBarProductWarehouse mt-16' placeholder={t('searchProductsDots', 'Buscar productos...')} changeSelectedItems={setData} id={'0'} fieldNotIn='Product.id' name='ProductId' url='/api/app/product/getAllProducts' where={{ 'productType': { '$not': [5] } }} />
    )
}

interface SelectorSearchbarDeciderComponentLogicProps {
    
}
const useSelectorSearchbarDeciderComponentLogic = () => {
    const [data, setData] = useState<ProductExtendedTyShort | null>(null)
    return { setData, data }
}

export default ModalCEWarehouseProduct